import Breadcrumb from '../../ui/components/Breadcrumb';
import HelpContactCard from '../../ui/components/HelpContactCard';
import PageTitle from '../buyerAndVendor/PageTitle';
import MulticolorDivider from '../../ui/components/MultiColorDivider';
import MainSection from '../../ui/components/MainSection';
import SideBarNav from '../../ui/components/SideBarNav';
import MainContentArticle from '../../ui/components/MainContentArticle';
import PoliciesMainContent from '../../ui/components/PoliciesMainContent';
import TopArticleCards from '../../ui/components/TopArticleCards';
import MarketplacePolicy from './MarketplacePolicy';

const routes = [
  { name: 'SmallSmall', href: '/' },
  { name: 'Support', href: '/' },
  { name: 'Marketplace guidelines', href: '/' },
];

export const dataContent = [
  { label: '1. General Principles', link: '#general-principles' },
  { label: '2. Guidelines for Buyers', link: '#guidelines-for-buyers' },
  { label: '3. Guidelines for Vendors', link: '#guidelines-for-vendors' },
  {
    label: '4. Prohibited Items and Services',
    link: '#prohibited-items-and-services',
  },
  { label: '5. Reviews and Ratings', link: '#reviews-and-ratings' },
  { label: '6. Payments and Fees', link: '#payments-and-fees' },
  { label: '7. Dispute Resolution', link: '#dispute-resolution' },
  {
    label: '8. Account Suspension and Termination',
    link: '#account-suspension-and-termination',
  },
  {
    label: '9. Data Protection & Privacy',
    link: '#data-protection-and-privacy',
  },
  {
    label: '10. Enforcement of Guidelines',
    link: '#enforcement-of-guidelines',
  },
  { label: '11. Policy Updates', link: '#policy-updates' },
  { label: '12. Contact Us', link: '#contact-us' },
];

function MarketplaceGuidelines() {
  return (
    <PoliciesMainContent>
      <Breadcrumb routes={routes} />
      <PageTitle title="Marketplace guidelines" />
      {/* <TopArticleCards title="Marketplace guidelines" /> */}
      <MulticolorDivider />
      <MainSection>
        <SideBarNav title="Marketplace articles" data={dataContent} />
        <MainContentArticle title="SmallSmall Marketplace Guidelines ">
          <p>
            Welcome to SmallSmall Technology Limited (“SmallSmall”). Our
            marketplace is built on trust, transparency, and fairness. These{' '}
            <strong>Marketplace Guidelines</strong> apply to both buyers and
            vendors and are designed to create a safe, reliable, and rewarding
            experience for everyone. By using the SmallSmall web or mobile
            application, you agree to abide by these guidelines, in addition to
            our{' '}
            <strong>
              Terms and Conditions, Buyer Protection Policy, Vendor Protection
              Policy, and Privacy Policy
            </strong>
            .
          </p>
          <MarketplacePolicy />
        </MainContentArticle>
      </MainSection>
      <HelpContactCard />
    </PoliciesMainContent>
  );
}

export default MarketplaceGuidelines;
